import { render, staticRenderFns } from "./OcrUserStoreMappingRegist.vue?vue&type=template&id=d995cb86&scoped=true&"
import script from "./OcrUserStoreMappingRegist.vue?vue&type=script&lang=js&"
export * from "./OcrUserStoreMappingRegist.vue?vue&type=script&lang=js&"
import style0 from "./OcrUserStoreMappingRegist.vue?vue&type=style&index=0&id=d995cb86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d995cb86",
  null
  
)

export default component.exports